// Trading Dashboard Table Component
export default {
  // Table Header
  totalRecords: "Total",
  records: "records",
  loading: "Loading...",

  // Table Column Headers
  blockchain: "Blockchain",
  address: "Address",
  transferInCount: "Transfer In Count",
  transferInAmount: "Transfer In Amount",
  transferOutCount: "Transfer Out Count",
  transferOutAmount: "Transfer Out Amount",
  remark: "Remark",
  action: "Action",

  // Remark Related
  addRemark: "Click to add remark",
  remarkSuccess: "Remark added successfully",

  // Action Buttons
  delete: "Delete",
  download: "Download Details",

  // Empty State
  noData: "No Data",

  // Messages
  addressNotFound: "Address not found",
  copySuccess: "Copied successfully!",
  deleteConfirm: "Are you sure to delete this address?",
  deleteSuccess: "Deleted successfully!",
  deleteCancelled: "Deletion cancelled",
  lastAddressWarning: "This is the last address and cannot be deleted",

  // Dialog
  tip: "Tip",
  confirm: "Confirm",
  cancel: "Cancel",
  warning: "Warning",
};
